import { render, staticRenderFns } from "./UberItems.vue?vue&type=template&id=19340528"
import script from "./UberItems.vue?vue&type=script&lang=js"
export * from "./UberItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports